module.exports=function(scope){ return `<!-- source object missing in request -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "You must pass a valid source object."
    }
}

<!-- target object missing in request -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "You must pass a valid target object."
    }
}

<!-- enrollmentIdentifier or faceMap missing in source or target -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "You must pass valid parameters."
    }
}


<!-- invalid json -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "Invalid json message received"
    }
}

<!-- enrollmentIdentifier not found in database -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "No entry found in the database for this enrollmentIdentifier."
    }
}

<!-- empty faceMap -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "Empty string not valid for parameter FaceMap."
    }
}


<!-- Source FaceMap is less then 20 characters -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "Source data length is < 20."
    }
}

<!-- Target FaceMap is less then 20 characters -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "Target data length is < 20."
    }
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/standard-server/response/failure/compare.json.tpl